import React, { useState, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Button,
  Typography,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const OrderDetailModal = ({ open, onClose, pedidoDetalles = [] }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);

  const filtrarDetalles = useMemo(() => {
    if (!searchTerm.trim()) return pedidoDetalles;

    const palabras = searchTerm.toLowerCase().split(/\s+/);

    return pedidoDetalles.filter((item) => {
      const texto = `${item.prd_code} ${item.orderhistdet_art.art_descripcion}`.toLowerCase();
      return palabras.every((palabra) => texto.includes(palabra));
    });
  }, [searchTerm, pedidoDetalles]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Detalles del Pedido
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {detalleSeleccionado ? (
          <>
            <Typography variant="subtitle1" fontWeight="bold">
              Código: {detalleSeleccionado.prd_code}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              Artículo: {detalleSeleccionado.orderhistdet_art.art_descripcion}
            </Typography>

            <Box
              sx={{
                maxHeight: 300,
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: 1,
                padding: 2,
                mt: 2,
                backgroundColor: '#f9f9f9'
              }}
            >
              <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                {detalleSeleccionado.ode_observacion || 'Sin observación'}
              </Typography>
            </Box>

            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={{ mt: 3 }}
              onClick={() => setDetalleSeleccionado(null)}
            >
              Volver
            </Button>
          </>
        ) : (
          <>
            <TextField
              fullWidth
              variant="outlined"
              label="Buscar artículo (código o descripción)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              margin="normal"
            />

            {filtrarDetalles.length > 0 ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Artículo</TableCell>
                    <TableCell>Cantidad</TableCell>
                    <TableCell>Precio</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Obs.</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtrarDetalles.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.prd_code}</TableCell>
                      <TableCell>{item.orderhistdet_art.art_descripcion}</TableCell>
                      <TableCell>{item.ode_quantity}</TableCell>
                      <TableCell>{item.ode_price}</TableCell>
                      <TableCell>{item.ode_total_amount}</TableCell>
                      <TableCell>
                        {item.ode_observacion ? (
                          <IconButton
                            color="primary"
                            onClick={() => setDetalleSeleccionado(item)}
                          >
                            <ArrowForwardIcon />
                          </IconButton>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Typography variant="body2">
                No hay resultados que coincidan con tu búsqueda.
              </Typography>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OrderDetailModal;
